import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=6b9c10a0&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=6b9c10a0&prod&lang=less&"
import style1 from "./pc.vue?vue&type=style&index=1&id=6b9c10a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c10a0",
  null
  
)

export default component.exports